import * as React from 'react';

export default function asyncComponent(importComponent: any) {
  interface OwnState {
    component: any;
  }

  class AsyncComponent extends React.PureComponent<{}, OwnState> {
    constructor(props: any) {
      super(props);

      this.state = {
        component: null,
      };
    }

    async componentDidMount() {
      if (importComponent) {
        const { default: component } = await importComponent();
        this.setState({ component });
      }
    }

    render() {
      const C = this.state.component;
      return C ? <C {...this.props} /> : null;
    }
  }

  return AsyncComponent;
}
